<template>
  <v-container>
    <v-overlay absolute :value="overlay" z-index="1000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col>
        <v-banner elevation="1">Históricos</v-banner>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="4" class="mr-auto">
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :return-value.sync="date"
          transition="scale-transition"
          offset-x
          min-width="auto"
        >
          <v-date-picker v-model="dates" locale="es-419" range>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu = false">
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.menu.save(date), getConversations()"
            >
              OK
            </v-btn>
          </v-date-picker>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateRangeText"
              label="Rango de fecha"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              solo
            ></v-text-field>
          </template>
        </v-menu>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" sm="6" md="4">
        <v-text-field
          v-model="search"
          prepend-icon="mdi-book-search"
          label="Buscar..."
          solo
          @keyup="filterConversations()"
        ></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto">
        <div class="text-center">
          <!-- <v-pagination
            v-model="page"
            :length="4"
            :total-visible="1"
          ></v-pagination> -->
          <!-- :input="getConversations()" -->
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-sheet elevation="1">
          <v-progress-linear
            indeterminate
            color="primary"
            v-if="loading"
          ></v-progress-linear>
          <v-simple-table cols="auto" elevation="9">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">
                    ID
                  </th>
                  <th class="text-center">
                    Inicio
                  </th>
                  <th class="text-center">
                    Canal
                  </th>
                  <th class="text-center">
                    ID del Cliente
                  </th>
                  <th class="text-center">
                    ID del Agente
                  </th>
                  <th class="text-center">
                    Status
                  </th>
                  <th class="text-center">
                    Opciones
                  </th>
                </tr>
              </thead>
              <tbody v-if="totalConversations > 0">
                <tr
                  class="text-center"
                  v-for="conversation in conversations"
                  :key="conversation.sessionId"
                >
                  <td>{{ conversation.sessionId }}</td>
                  <td>
                    {{
                      $moment(conversation.startDatetime * 1000).format(
                        "h:mma DD-MM-YYYY"
                      )
                    }}
                  </td>
                  <td>{{ conversation.channel }}</td>
                  <td>{{ conversation.clientId }}</td>
                  <td>{{ conversation.agentId }}</td>
                  <td v-if="conversation.status == 'CLOSED'" class="red--text">
                    {{ conversation.status }}
                  </td>
                  <td v-if="conversation.status == 'OPEN'" class="green--text">
                    {{ conversation.status }}
                  </td>
                  <td
                    v-if="conversation.status == 'QUEUE'"
                    class="yellow--text"
                  >
                    {{ conversation.status }}
                  </td>
                  <td>
                    <v-btn
                      color="primary"
                      fab
                      small
                      icon
                      @click="showMessages(conversation.sessionId)"
                    >
                      <v-icon>
                        mdi-message
                      </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
              <template v-else>
                <div class="float-right pa-4">
                  No hay registros
                </div>
              </template>
            </template>
          </v-simple-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" scrollable max-width="420px">
      <v-card min-width="100%">
        <v-card-title>Mensajes</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <Messages v-if="dialog" :id="conversationId" />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="alertSnackbar" :timeout="3000" top>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="alertSnackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { Config } from "../config";
import Messages from "../components/layouts/Messages";
export default {
  components: {
    Messages
  },
  data() {
    return {
      loading: false,
      alertSnackbar: false,
      snackbarText: "",
      overlay: false,
      date: this.$moment(),
      page: 1,
      totalPages: 4,
      currentPage: 1,
      perPage: 1,
      startDate: "",
      dates: [
        this.$moment(this.date).format("YYYY-MM-") +
          (parseInt(this.$moment(this.date).format("D")) > 15
            ? this.$moment(this.date)
                .subtract(15, "days")
                .format("DD")
            : "01"),
        this.$moment(this.date).format("YYYY-MM-DD")
      ],
      search: "",
      menu: false,
      conversations: {},
      dialog: false,
      conversationId: "",
      totalConversations: 0
    };
  },
  mounted() {
    this.dates = [
      this.$moment(this.date).format("YYYY-MM-") +
        (parseInt(this.$moment(this.date).format("D")) > 31
          ? this.$moment(this.date)
              .subtract(31, "days")
              .format("DD")
          : "01"),
      this.$moment(this.date).format("YYYY-MM-DD")
    ];
    this.getConversations();
  },
  computed: {
    dateRangeText() {
      return (
        this.formatDate(this.dates[0]) +
        (this.dates[1] ? " al " + this.formatDate(this.dates[1]) : "")
      );
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    validateRangeDates() {
      let startDate = this.$moment(this.dates[0]);
      let endDate = this.$moment(this.dates[1]);
      if (startDate > endDate) {
        let pStartDate = startDate;
        let pEndDate = endDate;
        startDate = pEndDate;
        endDate = pStartDate;
      }
      if (startDate.diff(endDate, "days") < -30) {
        return false;
      } else {
        return true;
      }
    },
    getConversations(search = false) {
      if (this.validateRangeDates()) {
        this.overlay = true;
        let startDate = this.$moment(`${this.dates[0]} 00:00`).format("X");
        let endDate =
          this.$moment(`${this.dates[1]} 23:59:59`).format("X") ==
          "Fecha inválida"
            ? this.$moment(`${this.dates[0]} 23:59:59`).format("X")
            : this.$moment(`${this.dates[1]} 23:59:59`).format("X");
        if (startDate > endDate) {
          let pStartDate = startDate;
          let pEndDate = endDate;
          startDate = pEndDate;
          endDate = pStartDate;
        }
        let params = {
          startDate: startDate,
          endDate: endDate
        };
        let url = `${Config.url}/db/conversations`;
        this.totalConversations = 0;
        this.axios
          .get(url, {
            params
          })
          .then(res => {
            if (!search) {
              this.totalConversations = res.data.totalConversations;
              this.conversations = res.data.conversations;
            } else {
              let arrayFilterConver = [];
              let searchConver = this.search.toLowerCase();
              this.conversations.map(item => {
                let id = item.sessionId.toLowerCase();
                let channel = item.channel.toLowerCase();
                let clientId = item.clientId.toLowerCase();
                let agentId = item.agentId.toLowerCase();
                if (
                  id.search(searchConver) != -1 ||
                  channel.search(searchConver) != -1 ||
                  clientId.search(searchConver) != -1 ||
                  agentId.search(searchConver) != -1
                ) {
                  arrayFilterConver.push(item);
                }
              });
              this.conversations = arrayFilterConver;
              this.totalConversations = this.conversations.length;
            }
            this.conversations.sort(function(a, b) {
              if (a.startDatetime > b.startDatetime) {
                return 1;
              }
              if (a.startDatetime < b.startDatetime) {
                return -1;
              }
              // a must be equal to b - when a is equal to b
              return 0;
            });
          })
          .catch(err => {
            console.log(err);
            this.snackbarText =
              "Error en servidor, falló al tratar de obtener lista de conversaciones";
            this.alertSnackbar = true;
          })
          .finally(() => {
            this.overlay = false;
          });
      } else {
        this.snackbarText = "Rango máximo permitido: 31 días";
        this.alertSnackbar = true;
      }
    },
    filterConversations() {
      this.getConversations();
      if (this.search != "") {
        this.getConversations(true);
      }
    },
    showMessages(id) {
      this.conversationId = id;
      this.dialog = true;
    }
  }
};
</script>

<style></style>
